import React, { useMemo } from "react";
import { Button, Box, Typography } from "@mui/material";
import { ConfirmationDialog } from "../../../../components/Dialog/ConfirmationDialog";
import { VALIDATION_MESSAGES } from "./constants";

interface ValidationErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errors?: {
    recordTypes?: string;
    enrichment?: string;
  };
}

export const ValidationErrorDialog: React.FC<ValidationErrorDialogProps> = ({
  open,
  onClose,
  errors,
}) => {
  // Create formatted error content with consistent styling
  const errorContent = useMemo(() => {
    const errorMessages: string[] = [];

    if (errors?.recordTypes) {
      errorMessages.push(errors.recordTypes);
    }

    if (errors?.enrichment) {
      errorMessages.push(errors.enrichment);
    }

    // Fallback to original message if no specific errors
    if (errorMessages.length === 0) {
      errorMessages.push(VALIDATION_MESSAGES.fallbackMessage);
    }

    // Always use consistent bullet point formatting
    return (
      <Box>
        {errorMessages.map((message, index) => (
          <Typography
            key={index}
            variant="body2"
            sx={{
              mb: index < errorMessages.length - 1 ? 1 : 0,
              lineHeight: 1.5,
            }}
          >
            • {message}
          </Typography>
        ))}
      </Box>
    );
  }, [errors]);

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      title={VALIDATION_MESSAGES.title}
      children={errorContent}
      actions={
        <Button
          id="hgForce-validation-error-dialog"
          variant="contained"
          onClick={onClose}
        >
          OK
        </Button>
      }
    />
  );
};
